'use client';

import { useCallback } from 'react';
import { useSearchParams } from 'next/navigation';
import { useRouter } from '@/i18n/routing';
import { CALLBACK_URL_PARAM } from '@/shared/constants/search-params';
import { isSafeRelativePath } from '@/shared/utils/safe-relative-path';

export type AuthRedirect = {
  redirectUrl: string;
  navigateWithCallback: (url: string) => void;
};

export const useAuthRedirect = (redirectUrlOverride?: string): AuthRedirect => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const requested = redirectUrlOverride ?? searchParams.get(CALLBACK_URL_PARAM);
  const redirectUrl = isSafeRelativePath(requested) ? requested : '';

  const navigateWithCallback = useCallback(
    (url: string) => {
      router.push(
        redirectUrl ? `${url}?${CALLBACK_URL_PARAM}=${encodeURIComponent(redirectUrl)}` : url,
      );
    },
    [redirectUrl, router],
  );

  return { redirectUrl, navigateWithCallback };
};
